import { stringify } from 'query-string';
import { apiFetch } from './utils/api';

const mockedPortfolioIndex = require('./mocks/v3/portfolio-index.json');

export const portfolioIndices = {
  get: async (args) => {
    const options = {
      method: 'GET',
    };

    const query = stringify(args, { arrayFormat: 'comma' });
    const url = `v3/portfolio/portfolio-index?${query}`;

    const { body } = await apiFetch(url, {
      ...options,
    });

    return body;
  },
};
